export const DEFAULT_WATER_COGENERATION_MODEL = `// Variables available to user:
  // "SteamRate_KPPH" : The rate of steam generation in kpph
  // "ElectricPower_MW" : The electricity generation in MW
  // Calculated Variables:
  // AuxiliaryHeatRequirement: The thermal requirement for generation of steam in BBtu(LHV)/d
  // Gas make ("GasMake_Flow") in MSCFD
  `;
